export default class OutreachDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ createdDate: Date; modifiedDate: Date; }' is missing the following properties from type 'Outreach': id, name, description, createdBy, and 2 more.
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate) });
    }
}
